import { Pagination, Spin, Tabs, Timeline } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActiveDotIcon,
  BackIcon,
  CloseIcon,
  InactiveDotIcon,
  Nst,
  Pu,
  Sh,
  St,
  Tf,
} from "../../../../asset";
import style from "./AllTripAdd.module.css";
import axios from "axios";
import { ROUTES } from "../../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import {
  GROLOG_ORDER_URL,
  GROLOG_URL,
  GROLOG_BASE_URL,
} from "../../../../constant/apiConstant";
import MapsRoute from "../../../../component/maps/MapsRoute";
import Geocode from "react-geocode";
import Breadcumbs from "../../../../component/page-components/breadcumbs/breadcumbs";
import { useSelector } from "react-redux";
import moment from "moment";
import MapsSingle from "../../../../component/maps/MapsSingle";
import CustomDivider from "../../../../component/divider/CustomDivider";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import ModalStartEndTrip from "../../../../component/modal/ModalStartEndTrip";

const AllTripDetail = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [directions, setDirections] = useState({});
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);
  const [rute, setRute] = useState([]);
  const [detailDepot, setDetailDepot] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageMap, setPageMap] = useState(1);
  const [dataCheck, setDataCheck] = useState([]);
  const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messages, setMessages] = useState("");
  const api = GROLOG_ORDER_URL;

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };
  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const fetchData = async () => {
    let id = 1;
    let tkn = token;
    let res = await doGet(`/all-trip/${location.state}?${param}`, tkn);
    setDetail(res?.data?.payload?.data);
    let listSelect = [];
    res?.data?.payload?.data?.order?.trip_route?.map((el) => {
      listSelect.push({
        address: el?.location,
        longitude: Number(el?.longitude),
        latitude: Number(el?.latitude),
        order_id: el?.order_id,
        order_number: el?.order_number,
        status: el?.order_status,
      });
    });
    setRute(listSelect);

    let resDepot = await doGets(
      `/depot-configuration/${res?.data?.payload?.data?.order?.depot_id}?${param}`,
      token
    );
    setDetailDepot(resDepot?.data?.payload?.data);
    // directionToMaps(pageMap)
  };
  const doGetBaseUrl = async (
    endpoint,
    tkn,
    params,
    dispatch,
    refresh_token
  ) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(
      `audit/v1/grolog/audit?page=1&filter=table_name eq order, primary_key eq ${location.state}&order=created_at desc`
    );

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data?.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element);
    }

    setManagementHistoryList(reorderedData);
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const monthNumbers = [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return `${dateFormat.getDate()}-${
        monthNames[dateFormat.getMonth()]
      }-${dateFormat.getFullYear()}`;
    } else {
      return `${dateFormat.getDate()}/${
        monthNumbers[dateFormat.getMonth()]
      }/${dateFormat.getFullYear()}`;
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };
  const backToList = () => {
    navigate(ROUTES.ALL_TRIP.LIST);
  };

  useEffect(() => {
    setLoading(true);
    fetchData();
    getManagementHistoryList();
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (rute.length !== 0 && window.google && detailDepot) {
      directionToMaps(pageMap);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rute, window.google, detailDepot]);

  const results = [];
  const chunkSize = 25;
  const tempArray = [...rute];
  // let way = [];
  let waypts = [];
  let way = [];
  const directionsService = new window.google.maps.DirectionsService();

  rute?.map((el, i) => {
    way.push({
      location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
      stopover: true,
    });
  });

  while (way.length) {
    results.push(way.splice(0, chunkSize));
  }

  let card = [];
  while (tempArray.length) {
    card.push(tempArray.splice(0, chunkSize));
  }
  const directionToMaps = (pg) => {
    setLoading(true);
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    let way = [];
    rute?.map((el, i) => {
      way.push({
        location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
        stopover: true,
      });
    });
    let resu = [];
    console.log("pesss", waypts);
    const directionsService = new window.google.maps.DirectionsService();

    console.log("waypts", pg);
    directionsService.route(
      {
        origin:
          pg === 1
            ? {
                lat: Number(detailDepot?.depot_profile?.depot_latitude),
                lng: Number(detailDepot?.depot_profile?.depot_longitude),
              }
            : {
                lat: Number(card[pg - 2][card[pg - 2]?.length - 1].latitude),
                lng: Number(card[pg - 2][card[pg - 2]?.length - 1].longitude),
              },
        destination:
          card.length >= 1
            ? {
                lat: card[pg - 1][card[pg - 1]?.length - 1]?.latitude,
                lng: card[pg - 1][card[pg - 1]?.length - 1]?.longitude,
              }
            : {
                lat: rute[rute?.length - 1]?.latitude,
                lng: rute[rute?.length - 1]?.longitude,
              },

        waypoints: results[pg - 1],
        optimizeWaypoints: true,
        travelMode: window.google.maps.TravelMode.DRIVING,
        // avoidHighways:true,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result);
          console.log("sini", result);
        }
      }
    );
    setLoading(false);
  };
  const handlePaginationMap = (a, b) => {
    if (a && b) {
      setPageMap(a);

      directionToMaps(a);
      // setLimitMap(b);
    } else {
    }
  };

  const Order = () => {
    return (
      <>
      
      <CustomDivider name={"Order Detail"} />
        {/* <div className="flex"> */}
          {/* <div> */}
            <div className="">
              <div className="gap-[40px] mb-[24px]">
                {/* <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Order Detail")}
                  </h3>
                </div> */}

                <div className="flex">
                  {/* //one */}
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Trip Name")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.order?.trip_name}
                      </h4>
                    </div>
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Trip Number")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.order?.trip_number}
                      </h4>
                    </div>
                  </div>

                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Trip ID")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.order?.trip_id}
                      </h4>
                    </div>
                  </div>
                </div>

                {/* <div className="w-[500px] mb-[24px]"> */}
                  {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Trip Route")}
                  </h3> */}
                {/* </div> */}
        <CustomDivider name={"Trip Route"} />
                {/* maps */}

                <div className="w-[1000px] mb-[50px] ml-[20px]">
                  {rute.length === 0 && !loading ? (
                    <MapsSingle
                      long={Number(detailDepot?.depot_profile?.depot_longitude)}
                      lat={Number(detailDepot?.depot_profile?.depot_latitude)}
                      trip={true}
                    />
                  ) : !loading ? (
                    <>
                      <MapsRoute
                        data={rute}
                        datas={card[pageMap - 1]}
                        directions={directions}
                        paging={pageMap}
                        // directions1={directions1}
                        // directions2={directions2}
                        // directions3={directions3}
                        long={
                          pageMap === 1
                            ? Number(
                                detailDepot?.depot_profile?.depot_longitude
                              )
                            : Number(
                                card[pageMap - 2][card[pageMap - 2]?.length - 1]
                                  .longitude
                              )
                        }
                        lat={
                          pageMap === 1
                            ? Number(detailDepot?.depot_profile?.depot_latitude)
                            : Number(
                                card[pageMap - 2][card[pageMap - 2]?.length - 1]
                                  .latitude
                              )
                        }
                      />
                      <div
                        id={"pageMap"}
                        className={style.Wrap + " justify-end flex"}
                      >
                        <div className="font-semibold text-base text-[#1D1D1D]">
                          {card[pageMap - 1].length} Of {rute.length} Order
                        </div>
                        <Pagination
                          // {...props}
                          onShowSizeChange={false}
                          size="small"
                          current={pageMap}
                          defaultCurrent={pageMap}
                          pageSize={25}
                          total={rute?.length}
                          // pageSizeOptions={initiate && initiate?.valid_limit}
                          // onShowSizeChange={() => handlePaginationMap()}
                          onChange={(value) => handlePaginationMap(value, 25)}
                        />
                      </div>
                      {/* <div >
                  <CustomPaging
                    idLimit="ddlrowsperpagemap"
                    idPagination="btnpaginationmap"
                    size="small"
                    current={pageMap}
                    defaultCurrent={pageMap}
                    pageSize={25}
                    total={rute?.length}
                    // pageSizeOptions={25}
                    onShowSizeChange={() => handlePaginationMap()}
                    handlePaging={(a, b) => handlePaginationMap(a, b)}
                    title={t("COMMON:ROW_PAGE")}
                  />
                </div> */}
                    </>
                  ) : (
                    <Spin size="large" />
                  )}
                </div>
              </div>
            </div>
          {/* </div> */}
        {/* </div> */}
      </>
    );
  };

  const DelivAso = () => {
    return (
      <>
        {/* <div className="flex">
          <div> */}
            <div className="">
              <div className="gap-[40px] mb-[24px]">
                {/* <div className="w-[500px] mb-[24px]">
                  <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                    {t("Driver Information")}
                  </h3>
                </div> */}
        <CustomDivider name={"Delivery Information"} />

                <div className="flex">
                  {/* //one */}
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Delivery Associate ID")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.delivery_associate?.delivery_associate_id}
                      </h4>
                    </div>
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Driver Phone")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.delivery_associate?.driver_phone}
                      </h4>
                    </div>
                  </div>
                  {/* line two */}
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Driver ID")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.delivery_associate?.driver_id}
                      </h4>
                    </div>
                  </div>
                  {/* line three */}
                  <div className="gap-[40px] mb-[24px]">
                    <div className="w-[350px] mb-[24px]">
                      <label className="font-roboto text-[14px] text-[#818181]">
                        {t("Driver Name")}
                      </label>
                      <h4 className="font-roboto text-[20px] text-[#424242]">
                        {detail?.delivery_associate?.driver_name}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          {/* </div>
        </div> */}
        {/* <div className="flex">
          <div className="gap-[40px] mb-[24px]"> */}
            {/* <div className="w-[500px] mb-[24px]">
              <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                {t("Driver Information")}
              </h3>
            </div> */}
        <CustomDivider name={"Driver Information"} />

            <div className="flex">
              {/* //one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Vehicle Model")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.delivery_associate?.vehicle_model}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Licence Plate")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.delivery_associate?.license_plate}
                  </h4>
                </div>
              </div>
            </div>
          {/* </div>
        </div> */}
      </>
    );
  };

  const Review = () => {
    return (
      <>
      <CustomDivider name={"Trip Detail"} />
        <div className="flex">
          <div className="gap-[40px] mb-[24px]">
            {/* <div className="w-[500px] mb-[24px]"> */}
              {/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                {t("Trip Detail")}
              </h3> */}
            {/* </div> */}

            <div className="flex">
              {/* //one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Trip Status")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.trip_status}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Cost")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_cost}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Left Capacity Weight")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.left_capacity_weight}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Volume of Trip")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_volume_of_trip}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Trip DIstance")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_trip_distance}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Trip Start Time")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {/* {detail?.review?.trip_start_time} */}
                    
                    {moment.parseZone(detail?.review?.trip_start_time).locale("id").format("DD/MM/YYYY")} | {moment.parseZone(detail?.review?.trip_start_time).locale("id").format("HH:mm")}
          </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Order")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_order}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Weight of Trip")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_weight_of_trip}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Left Capacity Unit")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.left_capacity_unit}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Estimation Time")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_estimation_time}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Trip End Time")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {/* {detail?.review?.trip_end_time} */}
                    {moment.parseZone(detail?.review?.trip_end_time).locale("id").format("DD/MM/YYYY")} | {moment.parseZone(detail?.review?.trip_end_time).locale("id").format("HH:mm")}
          </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Customer")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_customer}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Left Capacity Volume")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.left_capacity_volume}
                  </h4>
                </div>
                <div className="w-[350px] mb-[24px]">
                  <label className="font-roboto text-[14px] text-[#818181]">
                    {t("Total Unit of Trip")}
                  </label>
                  <h4 className="font-roboto text-[20px] text-[#424242]">
                    {detail?.review?.total_unit_of_trip}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("Order"),
      children: Order(),
    },
    {
      key: 2,
      label: t("Delivery Associate"),
      children: DelivAso(),
    },
    {
      key: 3,
      label: t("Review"),
      children: Review(),
    },
  ];

  const handleStart = (result) =>{
    setStartOpen(true)
    setDataCheck([result])
  }
  const handleEnd = (result) =>{
    setEndOpen(true)
    setDataCheck([result])
  }

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const onStartEnd = async (result) => {
    let cek = [];
    // let id=
    // dataCheck?.map((el) => {
    //   cek.push({
    //     id: el.id,
    //     updated_at: el.updated_at,
    //   });
    // });
    let list_trip = { list_trip: [{id:location?.state, updated_at: detail?.updated_at}]};

    try {
      let tkn = token;
      let res = await doPost(`/all-trip/${result}-trip?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      // message.success(_.startCase("Success Start Trip"));
      setMessages("Success Start Trip");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setStartOpen(false);
      }
    }
  };
  const handleClose = ()=>{
    setStartOpen(false)
    setEndOpen(false)
    setDataCheck([])
  }
  return (
    <>
    
    <ModalStartEndTrip
        visible={startOpen}
        message={`The trip status will change to "Start"
     and can't be edited`}
        titles="Start Trip"
        title="Start Trip"
        onClick={() => onStartEnd("start")}
        action={() => handleClose()}
      />
      <ModalStartEndTrip
        visible={endOpen}
        message={`The trip status will change to "End"
     and can't be edited`}
        titles="End Trip"
        title="End Trip"
        onClick={() => onStartEnd("end")}
        action={() => handleClose()}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcumbs
            jmlLevel={4}
            menuLevel1={`Order`}
            menuLevel2={`Routes`}
            menuLevel3={`All Trip`}
            menuLevel4={`Detail `+ detail?.order?.trip_name+ " - "+detail?.review?.total_order+ " Order"}
          />
        </div>

        <div className="flex items-center justify-between">
          <div onClick={() => backToList()} className="flex cursor-pointer items-center gap-[22px]">
            <img
              src={BackIcon}
              alt=""
              className="cursor-pointer"
            />
            <h1 className="font-sans-bold text-2xl" id="title">
              Detail {detail?.order?.trip_name} - {detail?.review?.total_order} Order
            </h1>
            <img
                src={
                  detail?.review?.no_trip_status === 1
                    ? Nst
                    : detail?.review?.no_trip_status === 2
                    ? St
                    : detail?.review?.no_trip_status === 3
                    ? Pu
                    : detail?.review?.no_trip_status === 4
                    ? Sh
                    : detail?.review?.no_trip_status === 6
                    ? Tf
                    : ""
                }
                alt="end-trip"
              />
          </div>
          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong>
            </p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>
        <div
          className="flex flex-row-reverse gap-[16px]"
        >
            <SecondaryButton
            // styles={props.styles}
            //   text={t("Yes, ")+props.title}
            disabled={detail?.review?.no_trip_status !==1}
              action={() => navigate(ROUTES.ALL_TRIP.DETAIL, { state: location.state})}
            text={t("Edit")}
            />
            
          {detail?.review?.no_trip_status ===1 ||detail?.review?.no_trip_status ===2 ?
          <PrimaryButton
            // text={t("USER_DETAIL:CANCEL")}
            // action={() => props.action()}
            text={detail?.review?.no_trip_status ===1 ? "Start Trip" : detail?.review?.no_trip_status ===2 ? "End Trip" : ""}
            action={()=>detail?.review?.no_trip_status ===1 ? handleStart() : detail?.review?.no_trip_status ===2 ? handleEnd() :""}
          />
          : <></>
}

          
        </div>
        <aside
          className={
            userManagementOpen
              ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
              : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"
          }
        >
          <button
            className="absolute top-[21px] right-[21px]"
            onClick={() => setUserManagementOpen(false)}
          >
            <img src={CloseIcon} alt="" />
          </button>

          <h3 className="font-sans font-[600] text-[#1D1D1D] text-[20px]">
            {t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}
          </h3>
          <p className="font-sans font-[400] text-[#818181] text-[12px] mb-[24px]">
            {t("USER_DETAIL:CREATED_BY")} <strong>{detail?.created_by}</strong>{" "}
            {t("USER_DETAIL:ON")}{" "}
            <strong>{convertTimestamp(detail?.created_at)}</strong>
          </p>

          <div className={style.timelineContainer}>
            <Timeline>
              {managementHistoryList.map((item, index) => {
                if (index === 0) {
                  return (
                    <Timeline.Item dot={<img src={ActiveDotIcon} />}>
                      <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                        <h4 className={"text-[#CF0000] font-[500] text-[14px]"}>
                          {t("USER_DETAIL:LAST_MODIFIED")}
                        </h4>
                        <h4 className="font-[500] text-[14px] text-[#424242]">
                          {item.alias_name}
                        </h4>
                        <p className="font-[400] text-[14px]">{`${convertTimestamp(
                          item.created_at
                        )} • ${convertToTime(item.created_at)}`}</p>
                      </div>
                    </Timeline.Item>
                  );
                } else {
                  return (
                    <Timeline.Item dot={<img src={InactiveDotIcon} />}>
                      <div className="flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]">
                        <h4 className={"font-[500]"}>
                          {t("USER_DETAIL:MODIFIED")}
                        </h4>
                        <h4 className="font-[500] text-[14px] text-[#424242]">
                          {item.alias_name}
                        </h4>
                        <p className="font-[400] text-[14px]">{`${convertTimestamp(
                          item.created_at
                        )} • ${convertToTime(item.created_at)}`}</p>
                      </div>
                    </Timeline.Item>
                  );
                }
              })}
            </Timeline>
          </div>
        </aside>
      </div>
    </>
  );
};
export default AllTripDetail;
